import React from 'react';
import { getGlobalTheme } from '@atlaskit/tokens';

const SmartSheetIcon = () => {
	const { colorMode } = getGlobalTheme();
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M5.65566 9.80586C5.65566 9.80586 6.65758 8.3702 8.03861 8.31602C10.1508 8.28893 11.8567 12.0542 12.1275 12.5959C14.4563 7.36795 18.3286 2.9526 21.4427 0H2.21663C2.21663 1.78781 2.24371 20.0993 2.24371 21.5892C2.24371 22.7539 2.08124 23.6208 2 24C2.86653 23.8916 6.08892 23.2957 9.36547 22.1309C15.2145 20.0181 17.5162 17.7968 17.5162 17.7698L17.6787 17.6072L17.7599 17.7968C17.7599 17.7968 18.4911 19.4492 19.1951 20.2889C20.0075 21.237 20.4408 21.3454 20.6845 21.2641C21.0094 21.1558 21.226 20.6411 21.3073 19.7472C21.3885 18.8804 21.4698 16.9029 21.4698 14.5192V1.67945C15.8644 8.61399 11.6672 19.0971 11.6672 19.0971C11.6672 19.0971 8.93221 9.7246 5.65566 9.80586Z"
				fill={colorMode === 'dark' ? '#FFFFFF' : '#003059'}
			/>
		</svg>
	);
};

export default SmartSheetIcon;
